




















































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import BpcHeaderLanguageSelector from '@shared/layouts/components/header/header-language-selector.vue';
import { ActivitySessionAttendee } from '@activities/interfaces/activity-session-attendee';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import Select from '@shared/components/forms/inputs/select/select.vue';
import store from '@app/store';
import BpcTextarea from '@shared/components/forms/inputs/textarea/textarea.vue';
import { setProp } from '@shared/helpers/operators';
import moment from 'moment';
import InputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';

@Component({
  name: 'bpc-public-summons-answer',
  components: {
    BpcHeaderLanguageSelector,
    ValidationProvider,
    ValidationObserver,
    'bpc-input-group': InputGroup,
    'bpc-select': Select,
    'bpc-textarea': BpcTextarea,
  },
})
export default class PublicSummonsAnswer extends Vue {
  @Prop(String) readonly attendeeId: string;
  @Prop(String) readonly answer: string;
  @Prop(String) readonly token: string;

  showAlertSuccess: boolean = false;
  showAlertDanger: boolean = false;
  alertMessage: string = '';
  defaultBackground: string = 'background-color: rgba(15, 58, 93, 0.85)';
  answered: boolean = false;
  extraAnswered: boolean = false;
  activityName: string = '';
  activitySessionName: string = '';
  activitySessionStartDate: string = '';
  attendeeName: string = '';
  canBeAnswered: boolean = false;
  formModel: Partial<ActivitySessionAttendee> = {
    id: null,
    coming: null,
    trip: null,
    available_places: null,
    not_coming_reason: null,
    not_coming_reason_description: null,
  };
  tripAttributes: object = {
    placeholder: this.$t('global.summons.trip.placeholder'),
    rules: ['required'],
    ...this.getCommonAttributes('trip'),
    showLabel: false,
    options: [
      {
        text: 'global.summons.trip.placeholder',
        value: null,
      },
      {
        text: 'activities.attendees.trip.has_vehicle',
        value: 'has_vehicle',
      },
      {
        text: 'activities.attendees.trip.need_vehicle',
        value: 'need_vehicle',
      },
      {
        text: 'activities.attendees.trip.going_directly',
        value: 'going_directly',
      },
    ],
  };
  availablePlacesAttributes: object = {
    placeholder: this.$t('global.summons.available_places.placeholder'),
    rules: ['required'],
    ...this.getCommonAttributes('available_places'),
    fieldAttributes: {
      autocomplete: 'off',
      type: 'number',
      step: '1',
    },
    showLabel: false,
  };
  notComingReasonAttributes: object = {
    placeholder: this.$t('global.summons.not_coming_reason.placeholder'),
    rules: ['required'],
    ...this.getCommonAttributes('not_coming_reason'),
    showLabel: false,
    options: [
      {
        text: 'global.summons.not_coming_reason.placeholder',
        value: null,
      },
      {
        text: 'activities.attendees.not_coming_reason.sick',
        value: 'sick',
      },
      {
        text: 'activities.attendees.not_coming_reason.studies',
        value: 'studies',
      },
      {
        text: 'activities.attendees.not_coming_reason.on_holiday',
        value: 'on_holiday',
      },
      {
        text: 'activities.attendees.not_coming_reason.other_activity',
        value: 'other_activity',
      },
      {
        text: 'activities.attendees.not_coming_reason.no_medical_certificate',
        value: 'no_medical_certificate',
      },
      {
        text: 'activities.attendees.not_coming_reason.other',
        value: 'other',
      },
    ],
  };
  notComingReasonDescriptionAttributes: object = {
    placeholder: this.$t('global.summons.not_coming_reason_description.placeholder'),
    rules: ['nullable'],
    ...this.getCommonAttributes('not_coming_reason_description'),
    showLabel: false,
  };
  private getCommonAttributes(name: string): object {
    return {
      id: `${name}`,
      showLabel: true,
      labelClass: 'label-class',
      labelAttributes: {
        for: `${name}`, // Set to the ID of the singular form-control in the form-group.
      },
      name: `${name}`,
      fieldClass: 'input-class',
      state: false,
      veeValidation: true,
      showError: true,
      errorClass: 'error-class',
      errorAttributes: {},
      error: 'error message',
      showHelp: false,
      helpClass: 'help-class',
      helpAttributes: {},
      help: `${name} help`,
      showFeedback: true,
      feedbackClass: 'feedback-class',
      feedbackAttributes: {},
      feedback: 'This is only for feedback',
    };
  }

  get tenantAlias(): string {
    return this.$clientRouter.getTenantAlias();
  }

  get tenantId() {
    return store.getters['tenant/selectedTenantId'];
  }

  get background() {
    return this.tenantBackground
      ? `background-image: url("${this.tenantBackground}")`
      : this.defaultBackground;
  }

  get logo() {
    return `background-image: url("${this.tenantLogo}")`;
  }

  get lang(): string {
    return this.$store.getters['auth/userLang'] || this.$i18n.locale;
  }

  confirmAnswer() {
    setProp(this.formModel, 'id', this.attendeeId);
    setProp(this.formModel, 'coming', this.answer);
    const url = this.$bpcApiRouteHelper.getEntityPath('activity-session-attendee');
    this.$bpcApi.patch(`${url}/${this.attendeeId}`, this.formModel).subscribe(res => {
      this.answered = true;
    });
  }

  confirmExtraAnswers() {
    if (
      (this.answer === 'yes' && this.formModel.trip) ||
      (this.answer === 'no' && this.formModel.not_coming_reason)
    ) {
      const url = this.$bpcApiRouteHelper.getEntityPath('activity-session-attendee');
      this.$bpcApi.patch(`${url}/${this.attendeeId}`, this.formModel).subscribe(res => {
        this.extraAnswered = true;
        this.showAlert('success', this.$t('global.thanks_summons_answer'));
      });
    } else {
      this.showAlert('danger', this.$t('global.summons.answer_needed'));
    }
  }

  showAlert(status, message) {
    this.alertMessage = message;
    this.showAlertSuccess = status === 'success';
    this.showAlertDanger = status === 'danger';
  }

  hideAlert() {
    this.alertMessage = '';
    this.showAlertSuccess = false;
    this.showAlertDanger = false;
  }

  async beforeMount() {
    if (!this.selectedUserLang && this.lang !== this.defaultLanguage) {
      await this.translationService.getTranslations(this.defaultLanguage);
    }
  }

  mounted() {
    // Check if the token corresponds to the attendee
    this.$bpcApi
      .get(
        `${this.$bpcApiRouteHelper.getEntityPath('activity-session-attendee')}/${this.attendeeId}`,
      )
      .subscribe(res => {
        this.attendeeName = res.data.attendee?.fullname;
        this.activityName = res.data.activity?.name;
        this.activitySessionName = res.data.activity_session?.name;
        this.activitySessionStartDate = res.data.activity_session?.start_date_time
          ? moment(res.data.activity_session.start_date_time).format('dddd DD/MM/YYYY HH:mm')
          : '';
        if (res.data.token === this.token) {
          if (res.data.activity_session?.start_date_time) {
            this.canBeAnswered = moment().isBefore(
              moment(res.data.activity_session.start_date_time),
            );
          } else {
            this.canBeAnswered = true;
          }
          if (this.canBeAnswered) {
            // Update the attendee with the answer (yes/no)
            this.confirmAnswer();
          } else {
            this.showAlert('danger', this.$t('global.summons.out_of_date'));
          }
        } else {
          this.showAlert('danger', this.$t('global.attendee_not_corresponds_to_the_user'));
        }
      });
  }

  get settingsLoaded() {
    return !this.$store.getters['centerSettings/isLoading'];
  }

  get availableLanguages() {
    if (this.$store.getters['centerSettings/centerSettings']) {
      return this.$store.getters['centerSettings/centerSettings'].available_languages;
    }
    return null;
  }

  get selectedUserLang() {
    return this.$store.getters['auth/userLang'];
  }

  get defaultLanguage() {
    if (this.$store.getters['centerSettings/centerSettings']) {
      return this.$store.getters['centerSettings/defaultLanguage'];
    }
    return null;
  }

  get tenantBackground() {
    if (
      this.$store.getters['centerSettings/centerSettings'] &&
      this.$store.getters['centerSettings/centerSettings'].background
    ) {
      let background = this.$store.getters['centerSettings/centerSettings'].background;
      if (typeof background === 'string') {
        background = JSON.parse(background);
      }
      return background.url;
    }
    return null;
  }

  get tenantLogo() {
    if (
      this.$store.getters['centerSettings/centerSettings'] &&
      this.$store.getters['centerSettings/centerSettings'].logo_url
    ) {
      let logo = this.$store.getters['centerSettings/centerSettings'].logo_url;
      if (logo && typeof logo === 'string') {
        logo = JSON.parse(logo);
      }
      return logo.url;
    }
    return null;
  }
}
